import { createInjectionKey } from "../../_utils/index.mjs";
export const treeSelectInjectionKey = createInjectionKey('n-tree-select');